import React from 'react';
import { RichTextEditor } from '@uber/rich-text-editor-lib';
import { styled, useStyletron } from 'baseui';
import { Block } from 'baseui/block';
import type { StyleObject } from 'styletron-react';
import { katexStyles } from './katex-styles';
const MarkDownBlock = styled(Block, {
  overflowY: 'auto',
  fontFamily: 'Uber Move',
  ...katexStyles
});
export type MarkDownPropsT = {
  src: string;
  styles?: StyleObject;
};
const MarkDown = ({
  src,
  styles = {}
}: MarkDownPropsT) => {
  const [css, theme] = useStyletron();
  if (!src) return null;
  return <MarkDownBlock data-testid="markdown" dir="auto" className={css({
    maxHeight: '500px',
    backgroundColor: theme.colors.backgroundPrimary,
    border: `1px solid ${theme.colors.contentSecondary}`,
    padding: theme.sizing.scale300,
    marginRight: theme.sizing.scale400,
    borderRadius: theme.sizing.scale100,
    ...styles
  })}>
      <RichTextEditor text={src} onChange={() => {}} readOnly toolbar={false} />
    </MarkDownBlock>;
};
export default MarkDown;